export class UserParams {
    public firstName: string = '';
    public lastName: string = '';
    public email: string = '';
    public retrievedEmail: string = '';
    public phone: string = '';
    public password: string = '';
    public populateSignupPage: boolean = false;
    public checkForDuplicate: boolean = true;
    public isSocialMediaSignup: boolean = false;
    public socialMediaType: string = '';
    public completeRegistration: boolean = false;
}
